import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function InvestDef({user}) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/InvestRisk");
    };

    const goPrev = () => {
        navigate("/HomeEducation");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user}/>
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Investing
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-4">
                    To invest in something is to spend money with the expectation of receiving a 
                </div>
                <div className="text-[#000000] text-3xl">
                    greater return sometime in the future.  For instance, a cat-lover buys a cell phone for 
                </div>
                <div className="text-[#000000] text-3xl">
                    $600.  The person then finds a bunch of cat videos on a video streaming site and is                     
                </div>
                <div className="text-[#000000] text-3xl">
                    very happy.  The investment is $600, and the return is the feeling of joy and a 
                </div>
                <div className="text-[#000000] text-3xl  ">
                    connection to the world for as long as the phone lasts.  This is the basis of financial 
                </div>
                <div className="text-[#000000] text-3xl  ">
                    investment.  You invest money into something to receive something more valuable 
                </div>
                <div className="text-[#000000] text-3xl  ">
                    in return at some point in the future.
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}